"use client";

import styled from "styled-components";

//Component
import { TooltipTrigger } from "../ui/tooltip";

interface ButtonProps {
  $variant?: "default" | "danger" | "warning" | "success" | undefined;
}

const variantStyles = {
  default: `
            background: transparent;
            color: var(--textLight);
            border: 1px solid var(--textLight);

            &:hover {
                background: rgba(75, 85, 99, 0.1);
            }
    `,
  danger: `
            background: var(--red);
            color: var(--white);

            &:hover {
                background: #bb1b1f;
            }
    `,
  warning: `
            background: var(--infoSystem);
            color: var(--colorTitle);

        &:hover {
            background: #ffd000;
        }
    `,
  success: `
        background: var(--primarySystem100);
        color: var(--white);

        &:hover {
            background: var(--primarySystem300);
        }
    `,
};

export const ButtonArround = styled(TooltipTrigger)<ButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  gap: 5px;
  border-radius: 50px;
  cursor: pointer;
  svg {
    width: 15px;
    height: 15px;
    stroke: var(--colorTitle);
  }

  ${({ $variant = "default" }) => variantStyles[$variant]}
`;
